import { render, staticRenderFns } from "./previewArticle.vue?vue&type=template&id=b466c4d6&scoped=true&"
import script from "./previewArticle.vue?vue&type=script&lang=js&"
export * from "./previewArticle.vue?vue&type=script&lang=js&"
import style0 from "./previewArticle.vue?vue&type=style&index=0&id=b466c4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b466c4d6",
  null
  
)

export default component.exports